import posthog from "posthog-js";
import { Logger } from "../helpers/logger.helpers";

export default {
  install(app, options = { apiKey: null, apiHost: null, enabled: true }) {
    const { apiKey, apiHost, enabled = true } = options;
    if (!enabled) {
      Logger.info("[Posthog::Plugin]: is disabled.");
      return;
    }

    if (!apiKey || !apiHost) {
      Logger.info("[Posthog::Plugin]: missing apiKey and/or apiHost.");
      return;
    }

    const _posthogInstance = posthog.init(apiKey, {
      api_host: apiHost,
      capture_pageview: false,
      autocapture: false,
    });
    // for option api
    app.config.globalProperties.$posthog = _posthogInstance;
    // for composition api
    app.provide("$posthog", _posthogInstance);
    Logger.info("[Posthog::Plugin]: is enabled.");
  },
};
